import React, { Component } from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line
import { connect } from 'react-redux';
import { Formik } from 'formik';
import _ from 'lodash';

import { Button } from 'react-bootstrap';

import { settings } from '../../lib/settings'; // eslint-disable-line
import { render } from '../../lib/helpers'; // eslint-disable-line
import
{
  addError,
  clearError,
  updateUser,
} from '../../redux/actions/Settings';

import Alert from '../Components/Alert';

import {
  validate,
  format,
  TextField,
  attachRefToFields,
} from '../Components/Form';


class MyAccountView extends Component {
  dismissError = () => {
    const { dispatch } = this.props;

    dispatch(clearError());
  };


  handleError(error) {
    const { dispatch } = this.props;

    dispatch(addError(error));
  }


  submit(userData) {
    const orgId = this.props.orgId;

    this.props.onFormSubmit(orgId, userData);
  }

  render() {
    const fields = this.props.values;

    const alertReshowToken = this.props.error ? this.props.error.instanceId : null;
    const errorDetails = this.props.error ? this.props.error.detail : null;
    const errorMessage = this.props.error ? this.props.error.message : null;
    const errorSubtitle = errorDetails ? 'Error Details:' : null;
    const hasError = !_.isNil(this.props.error);

    return (
      <div
        style={{
          padding: '48px',
          paddingBottom: '150px',
          width: '100%',
        }}
      >
        <h1>My Account</h1>
        {hasError && <Alert
          color='danger'
          reshowToken={alertReshowToken}
          details={errorDetails}
          message={errorMessage}
          subtitle={errorSubtitle}
          handleAction={this.dismissError}
        />}
        <Formik

          initialValues={{
            ...fields,
          }}

          ref={(c) => { this.form = c; }}
          enableReinitialize

          validate={values => validate(this, values)}

          onSubmit={async (values, { setSubmitting }) => { // eslint-disable-line
            let newValues = values;

            try {
              newValues = await format(this, values);
            } catch (err) {
              this.handleError(err);
              return;
            }

            setSubmitting(true);
            let resp;
            try {
              resp = await this.submit(newValues);
            } catch (err) {
              this.handleError(err);
            }

            setSubmitting(false);
            return resp;
          }}

          render={(props) => { // eslint-disable-line
            const page = this;
            return (
              <form onSubmit={props.handleSubmit}>
                <div className='form-group'>
                  <div className='row'>
                    <div style={{ width: '25%' }}>
                      <TextField
                        type='text'
                        name='first_name'
                        label='First Name'
                        required
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                      />
                    </div>
                    <div style={{ width: '25%' }}>
                      <TextField
                        type='text'
                        name='last_name'
                        label='Last Name'
                        required
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div style={{ width: '25%' }}>
                      <TextField
                        type='text'
                        name='title'
                        label='Title'
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                      />
                    </div>
                  </div>
                </div>
                <Button type='submit' bsStyle='primary'>Save</Button>
              </form>
            );
          }}
        />
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  // Form 'values' are actually 'settings.user'
  const { user: values, error } = state.settings;

  return {
    values,
    error,
  };
};


const mapDispatchToProps = dispatch => ({

  onFormSubmit: (orgId, userData) => dispatch(updateUser(orgId, userData)),
  dispatch,

});


MyAccountView.propTypes = {
  orgId: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.shape({}),
};

MyAccountView.defaultProps = {
  orgId: '',
  user: {},
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyAccountView);



// WEBPACK FOOTER //
// ./src/views/Pages/MyAccountView.js